import HTML from './html'

const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform)

class ModalRegister {
    constructor() {
        this.modals = []
    }

    add(modal) { this.modals.push(modal) }

    remove(modal) { this.modals.filter(m => m.guid !== modal.guid) }

    getVisible() { return this.modals.filter(m => m.visible) }

    numberOfVisible() { return this.getVisible().length }

    hasVisible() { return this.numberOfVisible() > 0 }

    hasMultipleVisible() { return this.numberOfVisible() > 1 }

    hideVisible() { this.getVisible().map(m => m.hide()) }
}

const modalRegister = new ModalRegister()

export default class Modal {

    constructor(options) {
        this.lastPageYOffset = window.pageYOffset
        Modal.prototype.nextZIndex = Modal.prototype.nextZIndex + 1
        var defOptions = {
            animationDuration: 300,
        }
        this.opts = $.extend(defOptions, options)
        this.events = {}
        this.contentRoot = $(
            HTML('div')
                .classes('rmodal__content__wrapper rmodal__content__wrapper--hidden')
                .render(),
        )
        this.root = $(
            HTML('aside')
                .classes('rmodal rmodal--hidden')
                .attr({ style: `zindex: ${Modal.prototype.nextZIndex}` })
                .append(
                    HTML('div')
                        .classes('rmodal__background')
                        .on('click', () => {
                            this.hide()
                        })
                        .render(),
                    HTML('div')
                        .classes('rmodal__content-wrapper')
                        .append(HTML('div')
                            .classes('rmodal__content')
                            .append(
                                HTML('a')
                                    .classes('rmodal__content__close-button')
                                    .attr({ href: '#' })
                                    .on('click', event => {
                                        event.preventDefault()
                                        this.hide()
                                    })
                                    .append(
                                        HTML('i').classes('icon icon-close').attr({ 'aria-hidden': 'true' }),
                                    ),
                                this.contentRoot.get(0),
                            ),
                        ),
                )
                .render(),
        )
        this.guid = '_' + Math.random().toString(36).substr(2, 9)
        this.visible = false
        this.blocked = false
        this.attach()

        modalRegister.add(this)
    }

    static create(...args) {
        return new Modal(...args)
    }

    attach() {
        this.__executeEvents('attach:before')
        document.body.appendChild(this.root.get(0))
        this.__executeEvents('attach:after')
        return this
    }

    detach() {
        this.__executeEvents('detach:before')
        document.body.removeChild(this.root.get(0))
        this.__executeEvents('detach:after')
        return this
    }

    destroy() {
        this.root.remove()
        for (let prop in this) {
            if (this.hasOwnProperty(prop)) {
                this[prop] = null
            }
        }
    }

    changeOptions(options) {
        this.opts = $.extend(this.opts, options)
        return this
    }

    __executeEvents(name, ...args) {
        if (this.events[name] instanceof Array) {
            this.events[name].map(event => event(this, args))
        }
    }

    on(name, callback) {
        if (typeof name !== 'string' || typeof callback !== 'function') {
            return
        }
        if (typeof this.events[name] === 'undefined') {
            this.events[name] = []
        }
        this.events[name].push(callback)
        return this
    }

    __doDelay(before, after) {
        if (typeof before === 'function') {
            before()
        }
        this.blocked = true
        setTimeout(() => {
            this.blocked = false
            if (typeof after === 'function') {
                after()
            }
        }, this.opts.animationDuration)
    }

    hide(callback) {
        if (this.blocked) {
            return
        }
        this.__doDelay(
            () => {
                this.contentRoot
                    .addClass('rmodal__content__wrapper--hidden')
                    .removeClass('rmodal__content__wrapper--visible')
                this.__executeEvents('hide:start')
            },
            () => {
                this.root.addClass('rmodal--hidden').removeClass('rmodal--visible')
                this.__executeEvents('hide:end')
                if (typeof callback === 'function') {
                    callback()
                }
                this.visible = false
                this._removeBodyClass()
            },
        )
        return this
    }

    show(callback) {
        if (this.blocked) {
            return
        }
        this.__doDelay(
            () => {
                this.root.removeClass('rmodal--hidden').addClass('rmodal--visible')
                this.__executeEvents('show:start')
            },
            () => {
                this.contentRoot
                    .removeClass('rmodal__content__wrapper--hidden')
                    .addClass('rmodal__content__wrapper--visible')
                this.__executeEvents('show:end')
                if (typeof callback === 'function') {
                    callback()
                }
                this.visible = true
                this._addBodyClass()
            },
        )
        return this
    }

    removeContent() {
        this.__executeEvents('contentRemove:before')
        this.contentRoot.empty()
        this.__executeEvents('contentRemove:after')
        return this
    }

    addContent(...content) {
        this.__executeEvents('contentAdd:before', content)
        !(content instanceof Array)
        ? this.contents = [content]
        : this.contents = content

        this.contents.map(block => {
            if (block && block.instanceOfHTML) {
                this.contentRoot.append(block.element)
            }

            if (typeof jQuery !== 'undefined' && block instanceof jQuery) {
                block.map((i, jqblock) => this.contentRoot.append(jqblock))
            }
            if (block instanceof Node || typeof block === 'string') {
                this.contentRoot.append(block)
            }
        })
        this.__executeEvents('contentAdd:after')
        return this
    }

    runPreloader() {
        this.defineContent(
            HTML('div')
                .classes('rmodal__preloader')
                .append(
                    HTML('i')
                        .classes('fa fa-spinner')
                        .attr({ 'aria-hidden': 'true' }),
                )
                .render(),
        )
        return this
    }

    defineContent(...content) {
        this.removeContent().addContent(...content)
        return this
    }

    _addBodyClass() {
        if (modalRegister.hasVisible()) {
            document.body.classList.add('rmodal-visible')
        }
        if (modalRegister.hasMultipleVisible()) {
            document.body.classList.add('rmodal-multiple-visible')
        }
        if (isIOS) {
            this.lastPageYOffset = window.pageYOffset
            window.scroll(0, 0)
            $('body > *').not('.rmodal--visible').addClass('just-hide')
        }
        return this
    }

    _removeBodyClass() {
        if (!modalRegister.hasVisible()) {
            document.body.classList.remove('rmodal-visible')
            if (isIOS) {
                $('body > *').not('.rmodal--visible').removeClass("just-hide");
                window.scroll(0, this.lastPageYOffset);
            }
        } else if (modalRegister.numberOfVisible() === 1) {
            document.body.classList.remove("rmodal-multiple-visible");
        }
        return this;
    }
}

Modal.prototype.nextZIndex = 10000;
